// Path Constants
export const API_BASE_URL = process.env.NODE_ENV === 'production' ? `https://inventory-api-719532976761.us-central1.run.app/api` : `http://localhost:8081/api`;
export const AUTH_URL = 'auth';
export const LOGIN_URL = AUTH_URL + '/login';
export const PROFILE_URL = AUTH_URL + '/user/me';
export const VALIDATE_TOKEN_URL = AUTH_URL + '/validate-token';
export const CHANGE_PASSWORD_URL = AUTH_URL + '/change-password';
export const USERS_URL = 'users';
export const SIGNUP_URL = USERS_URL + '/signup';
export const ITEMS_URL = 'items';
export const ITEMS_COUNT_URL = ITEMS_URL + '/count';
export const ITEMS_WITH_RECIPES_COUNT_URL = ITEMS_COUNT_URL + '/items-with-recipes';
export const ITEMS_UOMS_URL = ITEMS_URL + '/uoms';
export const STORES_URL = 'stores';
export const STORES_COUNT_URL = STORES_URL + '/count';
export const ITEM_ADJUSTMENTS_URL = '/item/adjustments';
export const ITEM_ADJUSTMENTS_COUNT_URL = ITEM_ADJUSTMENTS_URL + '/count';
export const ITEM_RECIPES_URL = '/item/recipes';
export const ITEM_TRANS_HEADERS_URL = '/item/trans/headers';
export const ITEM_TRANS_COUNT_URL = ITEM_TRANS_HEADERS_URL + '/count';
export const RAW_MATERIAL_RECEIPTS_COUNT = ITEM_TRANS_COUNT_URL + '/raw-material-receipts';
export const FINISH_GOOD_RECEIPTS_COUNT = ITEM_TRANS_COUNT_URL + '/finish-good-receipts';
export const PROCESSING_COUNT_URL = ITEM_TRANS_COUNT_URL + '/processing';
export const ISSUANCE_COUNT_URL = ITEM_TRANS_COUNT_URL + '/issuance';
export const ITEM_TRANS_DETAILS_URL = 'item/trans/details';
export const REPORTS_URL = '/reports';
export const COMPANIES_URL = 'companies';
export const ROLES_URL = 'roles';
export const ACTIVATION_STATUSES_URL = 'activation-statuses';
// Validation Constants
export const NOT_NULL = 'not null';
// Cloudinary Configurations
export const CLOUDINARY_CLOUD_NAME = 'dfjrd6q0w';
export const CLOUDINARY_UNSIGNED_PRESET = 'manufacturing-inventory-preset';
export const DEFAULT_COMPANY_LOGO = 'https://res.cloudinary.com/dfjrd6q0w/image/upload/v1773348166/default-tenant-logo_xy6jt5.svg';

// functions
export function getCurrentDateTime() {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  const hh = String(now.getHours()).padStart(2, '0');
  const mi = String(now.getMinutes()).padStart(2, '0');
  const ss = String(now.getSeconds()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}`;
}